// extracted by mini-css-extract-plugin
export var details = "_f3-0";
export var inspectorPopover = "_f3-1";